import moment from "moment";

interface BookingItem {
    _id?: string;
    serviceId?: string;
    service?: string; // Fallback for some structures
    from: string | Date;
    till?: string | Date;
}

/**
 * Checks if a booking conflicts with existing bookings.
 * A conflict occurs if the same service is booked for the same service + date + time slot.
 * 
 * @param newBooking The booking being created or updated
 * @param existingBookings List of existing bookings
 * @returns boolean True if there is a conflict, false otherwise
 */
export const checkBookingConflict = (
    newBooking: BookingItem,
    existingBookings: BookingItem[]
): boolean => {
    if (!newBooking.from || !newBooking.serviceId) return false;

    const newFrom = moment(newBooking.from);
    const newServiceId = newBooking.serviceId;
    const newId = newBooking._id;

    return existingBookings.some((existing) => {
        // Skip if it's the same booking we are editing
        if (newId && (existing._id === newId)) {
            return false;
        }

        const existingServiceId = existing.serviceId || (typeof existing.service === 'string' ? existing.service : (existing.service as any)?._id);
        const existingFrom = moment(existing.from);

        return (
            existingServiceId === newServiceId &&
            existingFrom.isSame(newFrom, 'minute')
        );
    });
};
